/* unplugin-vue-components disabled */import { ElMenuItem as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/menu-item/style/css';
import { ElSubMenu as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/sub-menu/style/css';
import "core-js/modules/es.array.push.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue";
var _hoisted_1 = {
  style: {
    "position": "relative"
  }
};
var _hoisted_2 = {
  key: 0,
  style: {
    "position": "absolute",
    "top": "15px",
    "right": "-10px",
    "display": "inline-block",
    "width": "7px",
    "height": "7px",
    "border-radius": "50%",
    "background-color": "red"
  }
};
import { useRouter } from 'vue-router';
import { onMounted, onUnmounted } from 'vue';
import { TUIStore, StoreName } from '@tencentcloud/chat-uikit-engine';
export default {
  __name: 'menuModule',
  props: ['menus'],
  setup(__props) {
    onMounted(() => {
      TUIStore.watch(StoreName.CONV, {
        totalUnreadCount: onCurrentTotalUpdated
      });
    });
    onUnmounted(() => {
      TUIStore.unwatch(StoreName.CONV, {
        totalUnreadCount: onCurrentTotalUpdated
      });
    });
    var total = ref('');
    function onCurrentTotalUpdated(val) {
      console.log("val->", val);
      total.value = val;
    }
    var router = useRouter();
    var props = __props;
    var filterData = data => {
      return data ? 'iconfont ' + data : '';
    };
    var change_item = item => {
      if (item.pc_path) {
        router.push(item.pc_path);
      }
    };
    return (_ctx, _cache) => {
      var _component_menu_module = _resolveComponent("menu-module", true);
      var _component_el_sub_menu = __unplugin_components_0;
      var _component_el_menu_item = __unplugin_components_1;
      return _openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.menus, item => {
        return _openBlock(), _createElementBlock(_Fragment, {
          key: item.title
        }, [item.child && item.child.length > 0 && item.type != 3 ? (_openBlock(), _createBlock(_component_el_sub_menu, {
          key: 0,
          index: item.code
        }, {
          title: _withCtx(() => [_createElementVNode("i", {
            class: _normalizeClass(filterData(item.icon))
          }, null, 2), _createElementVNode("span", null, _toDisplayString(item.title), 1)]),
          default: _withCtx(() => [_createVNode(_component_menu_module, {
            menus: item.child
          }, null, 8, ["menus"])]),
          _: 2
        }, 1032, ["index"])) : (_openBlock(), _createBlock(_component_el_menu_item, {
          key: 1,
          index: item.code,
          onClick: $event => change_item(item),
          disabled: item.dev_status == 2,
          class: _normalizeClass([item.code == 200 ? 'hide' : ''])
        }, {
          title: _withCtx(() => [_createElementVNode("p", _hoisted_1, [_createElementVNode("span", null, _toDisplayString(item.title), 1), item.code == 2200 && _unref(total) + item.notice > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_2)) : _createCommentVNode("", true)])]),
          default: _withCtx(() => [filterData(item.icon) ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            class: _normalizeClass(filterData(item.icon))
          }, null, 2)) : _createCommentVNode("", true)]),
          _: 2
        }, 1032, ["index", "onClick", "disabled", "class"]))], 64);
      }), 128);
    };
  }
};